import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountType, extractDefaultStoreId, extractNumber, HxCurrencyPipe, HxStoreService, StoreBasicModel, StoreMoneyInfoModel } from 'hx-services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HxStoreSelectComponent, HxToastrService } from 'hx-component';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-store-info',
    templateUrl: './store-info.component.html',
    styleUrls: ['./store-info.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, NgIf, RouterLink, TranslocoPipe, HxCurrencyPipe]
})
export class StoreInfoComponent implements OnInit, OnDestroy {
  storeId: number;
  storeMoneyInfo: StoreMoneyInfoModel;
  isLoading = {
    model: false,
  };
  Cash = AccountType.CASH;
  BankAccount = AccountType.BANK_ACCOUNT;
  private sub: Subscription;

  constructor(
    private storeService: HxStoreService,
    private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private toastr: HxToastrService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      if (this.storeId) {
        this.loadMoneyInfo();
      }
    });
    this.loadMoneyInfo();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  onStoreChanged(store?: StoreBasicModel | StoreBasicModel[]) {
    this.storeId = !Array.isArray(store) ? store?.id : undefined;
    this.navigate();
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: {
        storeId: this.storeId
      },
      relativeTo: this.aRoute
    });
  }

  private loadMoneyInfo() {
    this.isLoading.model = true;
    this.storeService.getStoreMoneyInfo(this.storeId).then(result => {
      this.isLoading.model = true;
      this.storeMoneyInfo = result;
    }).catch(() => this.isLoading.model = true);
  }
}
